import { AlkLogger } from '@alk/core';
import { ForwardPriceRequest, IForwardQuote, IPriceService } from '../../../interfaces';
import { injectable } from 'inversify';
import { Observable, of } from 'rxjs';

@injectable()
export class FwdPriceMock implements IPriceService {
    request(request: ForwardPriceRequest): boolean {
        AlkLogger.debug(`[FwdPriceMock#update] request: `, request);
        return true;
    }

    quoteObservable(): Observable<IForwardQuote> {
        AlkLogger.debug(`[FwdPriceMock#quoteObservable]`);
        return of({} as IForwardQuote);
    }

    stop(): void {
        AlkLogger.debug(`[FwdPriceMock#stop]`);
    }
}
